export default __webpack_public_path__ + "static/media/Lexi 9781408309070.449ed5cc.jpg";